import { Instruction } from "../Instruction";
import { ProgramModel } from "../ProgramContext";

export class ReferenceInstruction<T extends string> extends Instruction<T> {
  readonly type: T;

  constructor(private ref: string) {
    super();
    this.type = ("reference-" + this.ref) as T;
  }

  act(context: ProgramModel) {
    context.reference.push(this.ref);
  }
}
